export const AuthErasmus = ({ auth, handleChange, error, enguany }) => {

  return (<>
    <div className="row">
      <div className="col col-12 ">
        <h4> ACCEPTACIÓ beca Erasmus+ {enguany} Institut Jaume Mimó </h4>
        <p>

          L'alumnat que opti a participar a realitzar les seves pràctiques (en modalitat FCT) per al curs 2025-26 a alguna empresa de la Unió Europea
          accepta les clàusules que regeixen la convocatòria acadèmica reguladora.

          <br />
          <br />

          <label htmlFor="authErasmus1">
            <input type="checkbox" id="authErasmus1" name="authErasmus" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange(t.target.value) }} required />
            Accepto les clàusules del programa Erasmus
          </label>

          <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>

          <br />
          <br />


          L’acceptació de la beca implica, així mateix, la de les clàusules que regeixen la convocatòria i la de la normativa acadèmica reguladora dels programes internacionals de mobilitat de l’Institut Jaume Mimó, així com de les condicions establertes pel soci i/o empresa del país de destinació.
          Amb l’acceptació de la beca em comprometo a:
          <ul>
            <li>Assistir a les sessions preparatòries prèvies a l’estada.</li>
            <li>Dur a terme la mobilitat.</li>
            <li>Mantenir una actitud professional, proactiva i constructiva.</li>
            <li>No desvincular-me del centre ni dels mòduls que estigui cursant durant l’estada.</li>
            <li>Fer l’enquesta EUSurvey al final de l’estada.</li>
            <li>Retornar la documentació pertinent omplerta i signada a la tornada.</li>
            <li>Enviar un vídeo resum de l’experiència, un escrit i 5 fotos a la tornada.</li>
          </ul>

          Un cop acceptada la beca mitjançant aquest document, el fet de renunciar-hi més endavant té les següents conseqüències:
          Si renuncia a la <b>beca abans de marxar</b>:
          <ul>
            <li>No tindrà la possibilitat de gaudir de futures beques.</li>
            <li>En cas de no haver fet les pràctiques, l'institut no li buscarà una altra empresa.</li>
          </ul>
          Si decideix tornar abans <b>un cop l'Erasmus ha començat</b>:
          <ul>
            <li>Haurà de tornar la beca en la seva totalitat (segons conveni de subvenció).</li>
            <li>No tindrà la possibilitat de gaudir de futures beques.</li>
            <li>En cas de no haver fet les pràctiques, l'institut no li buscarà una altra empresa.</li>
          </ul>

          D’altra banda, el centre es reserva el dret de retirar la beca Erasmus+ si l’equip docent i/o l’equip de mobilitat ho creuen oportú per motius d’actitud, inestabilitat, etc en qualsevol moment.

        </p>


      </div>
    </div>

    <br />
  </>)
}
